import {FunctionComponent, ReactNode, useEffect, useState} from "react";

interface IProps {
    href: string;
    classes?: string;
    children: ReactNode
}

const Anchor:FunctionComponent<IProps> = ({ href, classes, children }) => {
    const [appendedQueries, setAppendedQueries] = useState("");

    useEffect(() => {
        if (window.location) {
            if (window.location.search) {
                setAppendedQueries(window.location.search);
            }
        }
    }, [])

    return <a href={`${href}${appendedQueries}`} className={classes}>{children}</a>
}

export default Anchor;